"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlag = useFeatureFlag;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _usePostHog = require("./usePostHog");
function useFeatureFlag(flag) {
  var posthog = (0, _usePostHog.usePostHog)();
  var _useState = (0, _react.useState)(posthog === null || posthog === void 0 ? void 0 : posthog.getFeatureFlag(flag)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    featureFlag = _useState2[0],
    setFeatureFlag = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!posthog) {
      return;
    }
    setFeatureFlag(posthog.getFeatureFlag(flag));
    return posthog.onFeatureFlags(function () {
      setFeatureFlag(posthog.getFeatureFlag(flag));
    });
  }, [posthog, flag]);
  return featureFlag;
}